import React from 'react';
import { Button } from '../../flayr-components/Button/Button';
import { Modal } from '../../flayr-components/Modal/Modal';

interface ICancellationPolicyModalProps {
  open?: boolean;
  onClose?: (e?: any) => void;
  message?: React.ReactNode;
  title?: string;
}

const CancellationPolicyModal: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICancellationPolicyModalProps>>> = ({
  open,
  onClose,
  message,
  title = 'COVID Cancellation',
}) => {
  return (
    <Modal title={title} onClose={onClose} open={open} size="sm">
      <p className="px-3 pb-5 my-8 text-gray-500">
        {message ||
          `
        If your event gets cancelled, rescheduled or you are unable to attend
        due to any border closures, as a result of Coronavirus (Covid-19), we
        can apply the deposit paid as a credit to your FLAYR account, so that
        you can use it on a deposit for a future booking within the next 6
        months.`}
      </p>

      <Button round size="lg" block color="hot-pink" onClick={onClose}>
        Close
      </Button>
    </Modal>
  );
};
export default CancellationPolicyModal;
